/*
 * - Definitions of Archive mutations
 */
import ArchiveService from './service';
import { ArchiveRequest, ArchiveRequestResponse, UnArchiveRequest, UnArchiveRequestResponse } from './types';
import { ResponseStatuses } from '@src/utils/enums';

export class ArchiveMutations {
  public static readonly archiveRequest = async (payload: ArchiveRequest): Promise<ArchiveRequestResponse> => {
    const response = await ArchiveService.archiveRequest(payload.requests);
    if (response.status !== ResponseStatuses.Success) {
      return Promise.reject(response.msg || 'Request archive failed');
    }
    return response;
  };

  public static readonly unArchiveRequest = async (payload: UnArchiveRequest): Promise<UnArchiveRequestResponse> => {
    const response = await ArchiveService.unArchiveRequest(payload.requests);
    if (response.status !== ResponseStatuses.Success) {
      return Promise.reject(response.msg || 'Request unarchive failed');
    }
    return response;
  };
}
